import { useCallback, useEffect, useRef } from 'react';

export const useBrowserNotification = () => {
  const currentNotificationRef = useRef(null);

  useEffect(() => {
    if (Notification.permission === 'default') {
      Notification.requestPermission();
    }
  }, []);

  const showNotification = useCallback((title, options = {}) => {
    if (Notification.permission !== 'granted') return;
    if (currentNotificationRef.current) {
      currentNotificationRef.current.close();
    }
    currentNotificationRef.current = new Notification(title, options);
  }, []);

  const closeNotification = useCallback(() => {
    if (currentNotificationRef.current) {
      currentNotificationRef.current.close();
      currentNotificationRef.current = null;
    }
  }, []);

  return { showNotification, closeNotification };
};
